
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    HostBinding,
    inject,
    input,
    signal
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { EntityFormModeType } from '@shared/types/entity-form-mode.type';
import {
    POSTerminalGraphQLSchema,
    POSTerminalGraphQLSchemaActions,
    POSTerminalGraphQLSchemaSelectors,
    POSTerminalType,
    POSTerminalTypeFormGroup,
    POSTerminalTypeFormGroupSelector,
    POSTerminalTypeQuery
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ObjectId, QueryFilterGroup } from 'zigra-ng-framework';
import { FloatLabel } from 'primeng/floatlabel';
import { ZFloatLabelComponent } from '@shared/components/form-components/z-float-label/z-float-label.component';
import { ZPosTerminalsSelectComponent } from '../z-pos-terminals-select/z-pos-terminals-select.component';
import { Button, ButtonModule } from 'primeng/button';
import { ZFloatLabelNumberComponent } from '@shared/components/form-components/z-float-label-number/z-float-label-number.component';
import { LoaderService } from '@shared/services/loader.service';
import { finalize } from 'rxjs';
import { ZionMessagesService } from '@shared/services/ax-messages.service';
import { ToastMessageOptions } from 'primeng/api';

@Component({
    selector: 'z-pos-terminal-edit',
    imports: [
    FormsModule,
    ReactiveFormsModule,
    ZFloatLabelComponent,
    ZPosTerminalsSelectComponent,
    ButtonModule
],
    templateUrl: './pos-terminal-edit.component.html',
    styleUrl: './pos-terminal-edit.component.scss'
    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class PosTerminalEditComponent {
    @HostBinding('style') style = 'height: 100%';
    productDialogMode = input<EntityFormModeType | undefined>(undefined);
    posTerminalId = input<ObjectId | undefined>(undefined);
    posTerminal = signal<POSTerminalType | undefined>(undefined);
    posTerminals = signal<POSTerminalType[] | undefined>(undefined);
    selectedPOSterminalId?: ObjectId;

    protected store = inject(Store);
    protected cd = inject(ChangeDetectorRef);
    protected loaderService = inject(LoaderService);
    protected messageService = inject(ZionMessagesService);
    protected formGroup?: POSTerminalTypeFormGroup;
    protected dialogConfig: DynamicDialogConfig<IPOSTerminalEditOptions> =
        inject(DynamicDialogConfig<IPOSTerminalEditOptions>);

    ngOnInit(): void {
        // this.productDepartment()?.Code;
        // this.productDepartment()?.Title;
        // this.productDepartment()?.Description;
        // this.productDepartment()?.ParentId;
        //this.productDepartment()?.VATCategoryId;

        //this.productPackage()?.InvoicingList?.[0]?.VATCategoryId

        const groupQuery = {
            GroupQuery: QueryFilterGroup.JoinWithOrOperator([
                QueryFilterGroup.FieldIsEqualToObjectId<POSTerminalType>(
                    ['_id'],
                    this.posTerminalId() ?? '000000000000000000000000'
                )
            ])
        };

        // if (this.posTerminalId() == undefined)
        //     this.posTerminal.set({
        //         Code: undefined,
        //         Title: undefined,
        //         Description: undefined
        //     } as POSTerminalType);
        // else
        this.store
            .dispatch(
                new POSTerminalGraphQLSchemaActions.Fetch(
                    queryForEdit,
                    undefined //groupQuery
                )
            )
            .subscribe(() => {
                const posTerminals = this.store.selectSnapshot(
                    POSTerminalGraphQLSchemaSelectors.FetchSelector('', '')
                )?.data?.Fetch;

                this.posTerminals.set(posTerminals);

                // const posTerminals =
                //     this.store.selectSnapshot(
                //         POSTerminalGraphQLSchemaSelectors.FetchSelector('', '')
                //     )?.data?.Fetch ?? [];

                this.posTerminal.set(this.posTerminals()?.[0]);
                this.selectedPOSterminalId = this.posTerminal()?._id;
                debugger;

                this.formGroup = new POSTerminalTypeFormGroup(
                    this.posTerminal(),
                    formForEditSelector
                );

                // debugger;
                // this.formGroup.clearValidators();
                // this.formGroup.controls.Parent?.patchValue(undefined as any);

                // this.formGroup.controls.Code?.addValidators([Validators.required]);
                // this.formGroup.controls.Code?.updateValueAndValidity();
                // this.formGroup.controls.Title?.addValidators([Validators.required]);
                // this.formGroup.controls.Title?.updateValueAndValidity();
                // this.formGroup.controls.Description?.addValidators(Validators.required);
                // this.formGroup.controls.Description?.updateValueAndValidity();
                // this.formGroup.controls.VATCategoryId?.addValidators(
                //     Validators.required
                // );
                // this.formGroup.controls.VATCategoryId?.updateValueAndValidity();

                // this.formGroup?.updateValueAndValidity();
                // this.formGroup?.markAllAsTouched();

                if (this.dialogConfig.data)
                    this.dialogConfig.data.posTerminalTypeFormGroup =
                        this.formGroup;

                this.cd.detectChanges();
            });
    }

    onSelectPOSTerminal(posTerminalId: ObjectId) {
        this.posTerminal.set(
            this.posTerminals()?.find(
                (posTerminal) => posTerminal._id == posTerminalId
            )
        );
    }

    savePOSTerminal() {
        const posTerminal = this.formGroup?.value as POSTerminalType;
        posTerminal.IP =
            posTerminal.IP?.trim() == '' ? undefined : posTerminal.IP?.trim();
        posTerminal.TerminalId =
            posTerminal.TerminalId?.trim() == ''
                ? undefined
                : posTerminal.TerminalId?.trim();
        posTerminal.Port =
            posTerminal.Port?.trim() == ''
                ? undefined
                : posTerminal.Port?.trim();

        this.loaderService.showAwaitDataSaveLoader();
        this.store
            .dispatch(
                new POSTerminalGraphQLSchemaActions.Upsert(
                    posTerminal,
                    undefined,
                    POSTerminalTypeQuery.GQLQuery()
                )
            )
            .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
            .subscribe(() => {
                this.messageService.add({
                    summary: 'Καταχώρηση POS Τερματικού',
                    detail: 'Η εγγραφή ενημερώθηκε επιτυχώς',
                    severity: 'success',
                    key: 'br'
                } as ToastMessageOptions);

                this.dialogConfig.data?.onSave(this.dialogConfig.data);
            });
    }
}

const queryForEdit = POSTerminalTypeQuery.GQLQueryWith();

const formForEditSelector = new POSTerminalTypeFormGroupSelector();

export interface IPOSTerminalEditOptions {
    mode: 'new' | 'edit' | 'view' | 'delete';
    //dclId?: number;
    //digitalClientCardType: DigitalClientCardType;
    posTerminalTypeFormGroup?: POSTerminalTypeFormGroup;

    onSave: (options: IPOSTerminalEditOptions) => void;
}
